import Vue from 'vue'
export class NoTrace {
    static captcha = null
    static captchaButton = null
    static success = null
    static buttonEl = null
    static executeFun = null
    static params = null
    static trackParams = null
    static init (element, button, { onClose } = {}) {
        NoTrace.captchaButton = document.getElementById(button);
        NoTrace.buttonEl = document.createElement('div')
        NoTrace.buttonEl.style = 'display: none'
        NoTrace.buttonEl.id = button
        document.body.appendChild(NoTrace.buttonEl)
        window.initAliyunCaptcha({
            SceneId: process.env.VUE_APP_SCENEID, // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
            prefix: process.env.VUE_APP_PREFIX, // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
            mode: 'popup', // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
            element: '#' + element, // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
            button: '#' + button, // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
            //captchaVerifyCallback: NoTrace.captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
            //onBizResultCallback: NoTrace.onBizResultCallback, // 业务请求结果回调函数，无需修改
            getInstance: NoTrace.getInstance, // 绑定验证码实例函数，无需修改
            slideStyle: {
                width: 340,
                height: 40,
            }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
            language: 'cn', // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
            success: NoTrace.captchaVerifyCallback,
            fail: function (result) {
                console.error('fail');
            },
            onClose: function (result) {
                // 入参为错误信息
                console.error(result);
                // 关闭弹窗
                Vue.prototype.$TsaEnvironmentCheck.hide()
                onClose && onClose()
            }
        });
    }
    static start (success, executeFun, params, trackParams) {
        NoTrace.success = success;
        NoTrace.executeFun = executeFun
        NoTrace.params = params
        NoTrace.trackParams = trackParams
        Vue.prototype.$TsaEnvironmentCheck.show({
            message: '智能验证检测中'
        })
        NoTrace.buttonEl.click()
    }
    static getInstance (instance) {
        NoTrace.captcha = instance;
    }
    static async captchaVerifyCallback (captchaVerifyParam) {
        let captchaResult = true
        console.log(222)
        if (NoTrace.executeFun) {
            NoTrace.params.nvc = captchaVerifyParam
            let trackParams = NoTrace.trackParams
            try {
                let result = await NoTrace.executeFun(NoTrace.params)
                // 接口验证成功 才是好的
                NoTrace.success && NoTrace.success(captchaVerifyParam);   
            } catch (error) {
                if (error && error.status === 403 && error.data && error.data.code === 600014) {
                    captchaResult = false
                }
                console.log(3333)
            }
            Vue.prototype.$TsaEnvironmentCheck.hide()
            NoTrace.reset();
            NoTrace.init('captcha-element', 'captcha-button')
        }
        return {
            captchaResult,
        }
    }
    static onBizResultCallback (result) {
        console.log('onBizResultCallback')
        // console.warn(result);
        // console.log('****')
    }
    static reset () {
        NoTrace.buttonEl && document.body.removeChild(NoTrace.buttonEl)
        NoTrace.buttonEl = null
        NoTrace.captchaButton = null;
        NoTrace.success = null;
        NoTrace.executeFun = null
        NoTrace.params = null
        NoTrace.trackParams = null
        // 必须删除相关元素，否则再次mount多次调用 initAliyunCaptcha 会导致多次回调 captchaVerifyCallback
        document.getElementById('aliyunCaptcha-mask')?.remove();
        document.getElementById('aliyunCaptcha-window-popup')?.remove();
    }
}

export default NoTrace